<template>
  <!-- 我要入会 右飘窗-->
  <!-- <div class="chuang_r" v-if="left_img">
    <a href="https://service.ccaa.org.cn/#/login" target="_blank"><img
        src="~@/assets/images/home/00fab83693bf6bef0abe9ba0a9a0220c.jpg" alt="" /></a>
    <img class="close" @click="close" src="~@/assets/images/home/close.gif" alt="" />
  </div> -->
</template>
<script>
export default {
  name: 'left',
  data() {
    return {
      left_img: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    close() {
      this.left_img = false
    }
  }
}
</script>
<style lang="scss" scoped>
.chuang_r {
  width: 115px;
  position: fixed;
  right: 0;
  top: 50%;
  margin-top: -210px;
  z-index: 9999;

  a {
    width: 115px;
    display: block;

    img {
      width: 100%;
    }
  }

  .close {
    width: 27px;
    margin: 10px auto 0 auto;
    display: block;
    cursor: pointer;
  }
}
</style>
